/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `daily` - Daily (weekdays)
 * * `weekly` - Weekly
 * * `none` - Off
 * @export
 */
export const DigestCadenceEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    None: 'none'
} as const;
export type DigestCadenceEnum = typeof DigestCadenceEnum[keyof typeof DigestCadenceEnum];


export function instanceOfDigestCadenceEnum(value: any): boolean {
    for (const key in DigestCadenceEnum) {
        if (Object.prototype.hasOwnProperty.call(DigestCadenceEnum, key)) {
            if (DigestCadenceEnum[key as keyof typeof DigestCadenceEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DigestCadenceEnumFromJSON(json: any): DigestCadenceEnum {
    return DigestCadenceEnumFromJSONTyped(json, false);
}

export function DigestCadenceEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigestCadenceEnum {
    return json as DigestCadenceEnum;
}

export function DigestCadenceEnumToJSON(value?: DigestCadenceEnum | null): any {
    return value as any;
}

export function DigestCadenceEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): DigestCadenceEnum {
    return value as DigestCadenceEnum;
}

